module.exports = __webpack_public_path__ + "static/media/business-growth.5612a47c.svg";